<template>
  <v-main class="page-form-overview">
    <portal to="app-bar">
      <v-app-bar
        app
        color="secondary"
        dark
      >
        <v-btn
          icon
          @click="$router.push({ name: 'home' })"
        >
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>

        <v-toolbar-title>{{ $t('form.index.titles.' + $route.meta.indexType) }}</v-toolbar-title>
      </v-app-bar>
    </portal>

    <v-dialog
      v-model="dialogOpen"
      persistent
      max-width="290"
    >
      <v-card>
        <v-card-title class="headline">
          {{ $t('form.index.start-form') }}
        </v-card-title>
        <v-card-text v-html="$t('form.index.start-warning', { time: startTime })" />
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="dialogOpen = false"
          >
            {{ $t('misc.cancel') }}
          </v-btn>
          <v-btn
            color="green darken-1"
            text
            @click="startForm"
          >
            {{ $t('misc.start') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-container>
      <v-list two-line>
        <v-list-item-group
          multiple
        >
          <template v-for="(project, index) of data">
            <v-list-item
              :key="index"
              @click.stop="openStartDialog(project)"
            >
              <template v-slot:default>
                <v-list-item-content>
                  <v-list-item-title v-text="project.name" />
                  <v-list-item-subtitle v-text="$t('form.index.received-at', { date: $d(Date.parse(project.createdAt), 'long') })" />
                </v-list-item-content>
              </template>
            </v-list-item>

            <v-divider
              v-if="index + 1 < data.length || hasMore"
              :key="index + '_d'"
            />
          </template>
        </v-list-item-group>

        <v-skeleton-loader
          v-if="hasMore"
          ref="skeleton"
          v-intersect.once="loadNextPage"
          type="list-item-three-line"
          class="mx-auto"
        />
      </v-list>
    </v-container>
  </v-main>
</template>

<script>
import moment from 'moment';
import { mapGetters } from 'vuex';

export default {
  data: () => ({
    data: [],
    page: 0,
    hasMore: null,
    dialogOpen: false,
    dialogProject: null,
    startTime: null
  }),
  computed: mapGetters({
    currentGroup: 'auth/currentGroup',
    user: 'auth/user'
  }),
  created () {
    this.loadNextPage();
  },
  methods: {
    openStartDialog (project) {
      this.startTime = moment().format('DD.MM.YYYY HH:mm');
      this.dialogProject = project;
      this.dialogOpen = true;
    },
    async startForm () {
      this.dialogOpen = false;

      let parseValue = (el) => {
        if (el.type === 'checkbox' && typeof(el.options.default) === 'string') {
          return (el.options.default === '') ? null : !!+el.options.default;
        }

        return el.options.default;
      };

      let data = {};
      for (let el of this.dialogProject.formMain) {
        if (el.options && el.options.default !== null && el.options.default !== undefined) {
          data[el.id] = parseValue(el);
        } else if (el.type === 'form_group' && el.options && !el.options.duplicateable) {
          data[el.id] = {};
          for (let groupEl of el.elements) {
            if (groupEl.options && groupEl.options.default !== null && groupEl.options.default !== undefined) {
              data[el.id][groupEl.id] = parseValue(groupEl);
            }
          }
        }
      }

      this.dialogProject.status = 1;
      await this.$pouch.put(this.dialogProject, { force: true }, 'projects');
      const doc = await this.$pouch.post({
        externalId: null,
        createdAt: (new Date()).toISOString(),
        data,
        form: this.dialogProject.formMain,
        projectId: this.dialogProject._id,
        lastUpdate: null,
        sentAt: null,
        synced: false
      }, null, 'project_data');
      this.$router.push({ name: 'form.show', params: { id: doc.id } });
    },
    async loadNextPage (e) {
      if (this.hasMore === false) return false;

      const selector = {
        createdAt: { $exists: true },
        deleted: { $eq: false },
        status: { $eq: (this.$route.meta.indexType === 'new') ? 0 : 1 }
      };
      if (this.currentGroup) {
        selector.groups = { $all: [this.currentGroup] };
      }

      this.hasMore = null;
      this.page++;
      const { docs } = await this.$pouch.find({
        selector,
        sort: [{ createdAt: 'desc' }],
        limit: 15,
        skip: (this.page - 1) * 15
      }, 'projects');

      this.data = this.data.concat(docs);
      this.$nextTick(() => {
        this.hasMore = docs.length >= 15;
      });

      return true;
    }
  }
};
</script>
